<header class="flex items-center justify-between bg-white px-6 py-2 shadow">
  <div class="w-full flex flex-row justify-between items-center gap-3">
    <!-- <p-button icon="pi pi-bars" (click)="toggleSidebar.emit()"></p-button> -->
    <p-treeselect
      class="w-100 general-business-treeselect h-[42px]"
      id="businessGroupFilter"
      [options]="businessGroupTree"
      [(ngModel)]="selectedBusinessGroup"
      (onNodeSelect)="onBusinessSelect($event)"
      placeholder="Seleccionar empresa"
      (ngModelChange)="onBusinessSelected($event)"
      [filter]="true"
      filterBy="label"
      [showClear]="false">
      <ng-template pTemplate="default" let-option>
        @if (option.data?.kind === 'all') {
          <app-business-logo
            [logoUrl]="option.data.logoUrl"
            [name]="option.data.name"
            logoSize="sm">
          </app-business-logo>
        } @else if (option.data?.kind === 'Group') {
          <app-business-logo
            [logoUrl]="option.data.logoUrl"
            [name]="option.data.name"
            logoSize="sm">
          </app-business-logo>
        } @else if (option.data?.kind === 'Business') {
          <app-business-logo
            [logoUrl]="option.data.logoUrl"
            [name]="option.data.name"
            logoSize="sm">
          </app-business-logo>
        } @else if (option.data?.kind === 'Office') {
          <div class="flex items-center gap-2">
            <span>{{ option.data.name }}</span>
          </div>
        }
      </ng-template>
      <ng-template #value let-selectedOption>
        @if (selectedOption?.data?.kind === 'all') {
          <app-business-logo
            [logoUrl]="selectedOption.data.logoUrl"
            [name]="selectedOption.data.name"
            logoSize="sm">
          </app-business-logo>
        } @else if (selectedOption?.data?.kind === 'Group') {
          <app-business-logo
            [logoUrl]="selectedOption.data.logoUrl"
            [name]="selectedOption.data.name"
            logoSize="sm">
          </app-business-logo>
        } @else if (selectedOption?.data?.kind === 'Business') {
          <app-business-logo
            [logoUrl]="selectedOption.data.logoUrl"
            [name]="selectedOption.data.name"
            logoSize="sm">
          </app-business-logo>
        } @else if (selectedOption?.data?.kind === 'Office') {
          <app-business-logo
            [logoUrl]="selectedOption.data.logoUrl"
            [name]="selectedOption.data.name"
            logoSize="sm"/>
        }
      </ng-template>
    </p-treeselect>

    <div class="card flex justify-center relative">
      <p-popover #userInfoPopover>
        <ng-template pTemplate="content">
          <div class="flex items-center gap-3 pb-3 border-b border-gray-200">
            <div class="h-12 w-12 rounded-full bg-primary flex items-center justify-center text-white font-semibold shadow-sm">
              {{ initialEmailCharacter || '' }}
            </div>
            <div class="flex flex-col">
              <span class="text-base font-semibold">{{ userFullName || 'Usuario' }}</span>
              <span class="text-sm text-gray-600">{{ userData?.Email || 'Correo no disponible' }}</span>
            </div>
          </div>

          <div class="pt-3 space-y-2 text-sm">
            <div class="text-gray-600 font-medium">Nombre y apellido</div>
            <div class="font-semibold">{{ userFullName || 'Información no disponible' }}</div>

            <div class="text-gray-600 font-medium">Correo</div>
            <div class="font-semibold">{{ userData?.Email || 'Información no disponible' }}</div>

            <div class="pt-3">
              <p-button
                label="Cerrar sesión"
                icon="pi pi-sign-out"
                styleClass="w-full p-button-text"
                (click)="logout(); userInfoPopover.hide()" />
            </div>
          </div>
        </ng-template>
      </p-popover>

      <p-button icon="pi" [rounded]="true" severity="primary" (click)="userInfoPopover.toggle($event)">
        <span class="text-white font-bold">{{ initialEmailCharacter || '' }}</span>
      </p-button>
    </div>
  </div>
</header>
